import { getToken } from '../auth/tokenStore';
import { TemplateBlock, TemplateBlockServer } from '../common/types';
import { apiBaseUrl } from '../index';

export const convertToClientRepresentation = (serverBlock: TemplateBlockServer): TemplateBlock => {
  return {
    ...serverBlock,
    id: serverBlock.id!,
    optArgs: serverBlock.optArgs || undefined
  };
};

export const createTemplateBlock = async (
  templateId: number,
  templateBlock: TemplateBlock
): Promise<TemplateBlock> => {
  const response = await fetch(apiBaseUrl + `/templates/${templateId}/template_blocks`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${await getToken()}`
    },
    body: JSON.stringify(templateBlock)
  });

  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }

  const serverBlock = await response.json();
  return convertToClientRepresentation(serverBlock);
};

export const updateTemplateBlockById = async (
  templateBlock: TemplateBlock
): Promise<TemplateBlock> => {
  const response = await fetch(apiBaseUrl + '/template_blocks/' + templateBlock.id, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${await getToken()}`
    },
    body: JSON.stringify(templateBlock)
  });

  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }

  const serverBlock = await response.json();
  return convertToClientRepresentation(serverBlock);
};

export const deleteTemplateBlockById = async (templateBlockId: number) => {
  const response = await fetch(apiBaseUrl + '/template_blocks/' + templateBlockId, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${await getToken()}`
    }
  });

  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }

  return;
};
